import { useState, useEffect } from "react";
import { Formik, Form } from "formik";
import { useInfiniteQuery } from "@tanstack/react-query";
import { useInView } from "react-intersection-observer";
import { Button, Loading } from "../../components";
import { SearchIcon } from "../../assets/icons";
import { TextInput } from "../../components/forms";
import useCustomerService from "../../services/api/customerService";
import dateFormatter from "../../util/dateFormatter";

function ExistingCustomersTab({ onSelect }) {
  const [searchQuery, setSearchQuery] = useState("");
  const { getAllCustomers, queryKey } = useCustomerService();
  const { ref, inView } = useInView();

  const { data, fetchNextPage, hasNextPage, isFetchingNextPage, isLoading } =
    useInfiniteQuery({
      queryKey: [queryKey, searchQuery],
      queryFn: ({ pageParam = 1 }) =>
        getAllCustomers(searchQuery, "", pageParam),
      getNextPageParam: (lastPage) => {
        if (lastPage?.currentPage < lastPage?.totalPages) {
          return lastPage.currentPage + 1;
        }
        return undefined;
      },
      initialPageParam: 1,
    });

  useEffect(() => {
    if (inView && hasNextPage) {
      fetchNextPage();
    }
  }, [inView, fetchNextPage, hasNextPage]);

  const handleSearch = (values) => {
    setSearchQuery(values.query);
  };

  return (
    <>
      <Formik initialValues={{ query: "" }} onSubmit={handleSearch}>
        <Form>
          <TextInput
            name="query"
            type="search"
            label="Search by Name or Phone number"
            placeholder="Enter customer name of phone number"
          />
          <Button text="Search" icon={<SearchIcon />} type="submit" />
        </Form>
      </Formik>

      <div className="customers-list">
        <div className="table-title">
          <h3>Search Results</h3>
        </div>
        <div className="table-content">
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Mobile Number</th>
                <th>Last Order</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {data?.pages.map((page) =>
                page.customers.map((customer) => (
                  <tr key={customer._id}>
                    <td>
                      {customer.title} {customer.name}
                    </td>
                    <td>{customer.mobileNumber}</td>
                    <td>{dateFormatter(customer.lastOrderDate) || "-"}</td>
                    <td>
                      <Button
                        text="Select"
                        onClick={() =>
                          onSelect((prev) => ({
                            ...prev,
                            customer: customer?._id || null,
                          }))
                        }
                      />
                    </td>
                  </tr>
                )),
              )}
              {data?.pages[0]?.customers?.length === 0 && !isLoading && (
                <tr>
                  <td colSpan="4" style={{ textAlign: "center" }}>
                    No customers found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          <div
            ref={ref}
            style={{
              width: "100%",
              height: "20px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Loading isLoading={isFetchingNextPage} variant="inline" />
          </div>
        </div>
      </div>
    </>
  );
}
export default ExistingCustomersTab;
